import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ShipmentRuleResponse } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule/shipment-rule.dto'
import ShipmentRuleService from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule/shipment-rule.service'
import ManualShipmentRuleService from '@/modules/configurationModule/detail/shipments/shipment-rules/services/manual-shipment-rule/manual-shipment-rule.service'
import { StrictNullable } from '@/shared/types/app.types'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'

export const columnsDefShipmentRulesGrid =
    (isManual: boolean): ColDef[] => {
        const columns: ColDef[] = [
            { type: AgGridColumnType.CUSTOM_CHECKBOX },
            {
                type: AgGridColumnType.LABORATORIES,
                headerName: i18n.tc('configuration.grid.ownerCenter'),
                field: 'caseOwnerLaboratory.labName',
                minWidth: 150,
                flex: 1
            },
            {
                type: AgGridColumnType.SHIPMENT_CORE_ENTITY,
                headerName: i18n.tc('configuration.grid.elementType'),
                field: 'entityType',
                minWidth: 150,
                flex: 1
            },
            {
                type: AgGridColumnType.LABORATORIES,
                headerName: i18n.tc('configuration.grid.originCenter'),
                field: 'originLaboratory.labName',
                minWidth: 150,
                flex: 1
            },
            {
                type: AgGridColumnType.LABORATORIES,
                headerName: i18n.tc('configuration.grid.destinationCenter'),
                field: 'destinationLaboratory.labName',
                minWidth: 150,
                flex: 1
            },
            {
                type: AgGridColumnType.SHIPMENT_ENTITY_STATUS,
                headerName: i18n.tc('configuration.grid.originStatus'),
                field: 'originEntityInternalStatus',
                colId: 'originEntityInternalStatusId',
                minWidth: 150,
                sortable: true,
                filter: false
            },
            {
                type: AgGridColumnType.SHIPMENT_ENTITY_STATUS,
                headerName: i18n.tc('configuration.grid.destinationStatus'),
                field: 'destinationEntityInternalStatus',
                colId: 'destinationEntityInternalStatusId',
                minWidth: 150,
                filter: false,
                sortable: true
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('configuration.grid.sampleType'),
                field: 'sampleType.description',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                sortable: true
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('configuration.grid.location'),
                colId: 'topographicCode.description',
                field: 'topographicCode',
                minWidth: 150,
                flex: 1,
                cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
                suppressSizeToFit: true,
                sortable: false
            },
            {
                type: AgGridColumnType.CHECK_ICON,
                headerName: i18n.tc('configuration.grid.active'),
                field: 'active',
                minWidth: 80,
                suppressSizeToFit: true
            }
        ]
        if (!isManual) {
            columns.push({
                type: AgGridColumnType.NUMBER,
                headerName: i18n.tc('configuration.grid.priority'),
                field: 'priority',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true
            })
        }
        return columns
    }

export type ShipmentRulesGridServiceType = ShipmentRuleService | ManualShipmentRuleService

export interface ShipmentRulesGridState extends CrudModelPaginator<ShipmentRuleResponse> {
    service: StrictNullable<ShipmentRulesGridServiceType>
    statesLoaded: boolean
}
export const initialShipmentRulesGridState =
    (service: StrictNullable<ShipmentRulesGridServiceType>): ShipmentRulesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.shipments.shipmentRules',
        service,
        statesLoaded: false
    })
